import { TradeInPreviewAcquisition } from '@carvana/merch-contracts';

/**
 * Pure trade selection shared by the client hooks (useGetTrades, useRefreshTradeDetails) and the
 * server seed (getTrades). Callers keep their own cookie writes / logging / setSelectedTrade side
 * effects and pass in the guarded query-param value + cookie id. An empty/undefined queryParamName
 * matches no real trade id, collapsing to the cookie ?? first pick.
 */
export default function selectPreferredTrade(
  trades: TradeInPreviewAcquisition[],
  queryParamName: string | undefined,
  cookieId: string
): TradeInPreviewAcquisition | null {
  if (trades.length <= 1) {
    return trades.at(0) ?? null;
  }

  return (
    trades.find(trade => trade.id === queryParamName) ??
    trades.find(trade => trade.id === cookieId) ??
    trades[0]
  );
}
